import React from 'react';

export const KeyImage = () => {
  return (
    <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.78125 4.5C0.78125 2.51523 2.39023 0.90625 4.375 0.90625C5.73786 0.90625 6.92265 1.66482 7.53175 2.78125H13.125C13.7291 2.78125 14.2188 3.27094 14.2188 3.875V5.4375C14.2188 5.69638 14.0089 5.90625 13.75 5.90625H12.3438V7C12.3438 7.25888 12.1339 7.46875 11.875 7.46875H10.3125C10.0536 7.46875 9.84375 7.25888 9.84375 7V5.90625H7.68305C7.13587 7.19177 5.86129 8.09375 4.375 8.09375C2.39023 8.09375 0.78125 6.48477 0.78125 4.5ZM4.375 3.25C3.68464 3.25 3.125 3.80964 3.125 4.5C3.125 5.19036 3.68464 5.75 4.375 5.75C5.06536 5.75 5.625 5.19036 5.625 4.5C5.625 3.80964 5.06536 3.25 4.375 3.25Z"
      />
    </svg>
  );
};
